#import "../../../../../common/graphql/EntityDocumentsFields.graphql"
query InvoiceDetails($id: UUID!) {
  invoice(id: $id) {
    id
    __typename
    _urgencyLevel
    transactionType {
      transactionType
      layoutType
      isDocumentSigningPayment
    }
    vendorReference
    description
    invoiceNumber
    invoiceDate
    departmentId
    department {
      name
    }
    controlTotalAmount
    _baseCurrencyAmount
    _spotCurrencyAmount
    additionalStatusType {
      statusType
    }
    businessUnit {
      name
      _isProductionBusinessUnit
    }
    _documentPackageId
    approvalTriggerDate
    _elapsedTriggerDays
    _linkedInvoiceId
    statusHintOverrideId
    statusHintOverride
    _receiptsTotal
    additionalInformationStatus
    _isEnvironmentalsExist
    _rowTimestamp

    reimburseAmount
    reimburseAccountReference
    entityAppliedAmounts {
      appliedTotal
      usedTotal
    }
    company {
      id
      name
    }

    vendorId
    currencyId
    currency {
      id
      isoCode
    }

    businessUnitId
    corporatePeriodId
    transactionTypeId

    isDraft
    _isDeletable
    _isStagedApprovalRequest
    _isApprovalRevocable
    _isApprovalHistoryExists
    _isUserApprovalTreeViewer
    _isApprovalDocumentsRequired
    _requiredApprovalDocuments
    _isDocumentsExist
    _statusTypeId
    _isUpdatable
    _isProtected
    _isTransactionCancelled
    bankAccountName
    bankAccountNumber
    bankIbanCode
    bankName
    bankRoutingNumber
    bankSortCode
    bankSwiftCode
    cardHolderId
    cardHolder {
      cardFirstName
      cardLastName
      cardNumber
    }
    invoiceDistributions(orderBy: [_CREATED_DATE_ASC, ACCOUNT_REFERENCE_ASC]) {
      aggregates {
        sum {
          distributionAmount
        }
      }
      nodes {
        id
        _createdDate
        _isDeletable
        _isUpdatable
        _rowTimestamp
        accountReference
        _accountName
        additionalDescription
        distributionAmount
        businessUnitId
        departmentId
        productionIncentiveId
        projectReference
        purchaseOrderReference
        documentFileDistributionId
        poEntityDocumentId
        isPoCharge
        statusTypeId
        setReference
        tax1099T4TypeId
        referenceCode1
        referenceCode2
        referenceCode3
        referenceCode4
        referenceCode5
        referenceCode6
        referenceCode7
        _ff1Name
        _ff2Name
        _ff3Name
        _ff4Name
        statusExplanation
      }
    }
    secureRowLevel {
      id
      name
      description
      securityLevel
    }
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
    invoiceHistoriesByEntityId {
      nodes {
        crudOperation
        pointInTimeDate
        tenantUserName
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _rowTimestamp
        _createdDate
        createdByUser
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
        documentPosition
      }
    }
    lookupName {
      lookupName
      id
      isApprovedVendor
      lookupCode
      lookupName
      lookupName2
      address1
      address2
      city
      state
      zipCode
      country
      phone
      emailAccount
    }
    userMessagesByEntityId {
      totalCount
    }
    statusType {
      statusType
      approvalState
      isDraftReleaseRequired
      _transactionIconStatus
    }
    entityEnvironmentalsByEntityId {
      nodes {
        environmentalMetric {
          environmentalMetric
          layoutType
        }
        description
        endDate
        startDate
        _rowTimestamp
        _createdDate
        id
        _isDeletable
        _isUpdatable
        environmentalMetricId
        entityEnvironmentalItems(
          orderBy: ENVIRONMENTAL_IMPACT_TYPE_BY_ENVIRONMENTAL_IMPACT_TYPE_ID__SORT_ORDER_ASC
        ) {
          nodes {
            __typename
            carbonCreditsAmount
            entityEnvironmentalId
            environmentalImpactTypeId
            _isIntegerFormat
            _isFloatFormat
            _isAmountFormat
            feet
            gallons
            hours
            id
            kilogram
            kilometers
            kilowattHours
            litres
            meters
            metricTonnes
            miles
            omissionsEquivalent
            pounds
            quantity
            therms
            tons
            yards
            _rowTimestamp
            _isUpdatable
            _isDeletable
            environmentalImpactType {
              environmentalImpact
            }
          }
        }
      }
    }
    approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
  }
}
